import React from "react";
import { Route, Switch as BrowserRouter } from "react-router-dom";
import jioGlassTNC from "../pages/jioglass-tnc";
import jioGlassPrivacyPolicy from "../pages/jioglass-privacy-policy";
import jioimmerseIosPrivacypolicy from "../pages/jioimmerse-ios-privacy-policy";
import JioimmerseAndroidPrivacyPolicy from "../pages/jioimmerse-android-privacypolicy";
import jioimmerseIosTnc from "../pages/jioimmerse-ios-tnc";
import JioimmerseAndroidTnc from "../pages/jioimmerse-android-tnc";
import JioPhotosAndroidTNC from "../pages/jiophotos_android-tnc";
import JioPhotosIosTNC from "../pages/jiophotos_ios-tnc";
import JioPhotosAndroidPrivacyPolicy from "../pages/jiophotos_android-privacy-policy";
import JioPhotosIosPrivacyPolicy from "../pages/jiophotos_ios-privacy-policy";
import JioPhotosAndroidLicences from "../pages/jiophotos_android-licences";
import JioPhotosIosLicences from "../pages/jiophotos_ios-licences";
import TesseractPortalAndroidTNC from "../pages/tesseractportal-android-tnc";
import TesseractPortalIosTNC from "../pages/tesseractportal-ios-tnc";
import TesseractPortalAndroidPrivacyPolicy from "../pages/tesseractportal-android-privacypolicy";
import TesseractPortalIosPrivacyPolicy from "../pages/tesseractportal-ios-privacypolicy";
import Licences from "../pages/Licences";
import TesseractEnterpriseTNC from "../pages/tesseract-enterprise-tnc";
import TesseractEnterprisePrivacyPolicy from "../pages/tesseract-enterprise-privacy-policy";

import HorizonPP from "../pages/HorizonPP";
import HorizonTNC from "../pages/HorizonTNC";
import HorizonMaster from "../pages/HorizonMasterContract";
import JioimmerseDesktopTnc from "../pages/jioimmerse-desktop-tnc";
import JioimmerseDesktopPrivacyPolicy from "../pages/jioimmerse-desktop-privacypolicy";

const Routes = () => {
  return (
    <div className="routesContainer">
      <BrowserRouter>
        <Route
          exact
          path="/jioglass-terms-and-conditions"
          component={jioGlassTNC}
        />
        <Route
          exact
          path="/jioimmerse-android/terms-and-conditions"
          component={JioimmerseAndroidTnc}
        />
        <Route
          exact
          path="/jioimmerse-ios/terms-and-conditions"
          component={jioimmerseIosTnc}
        />
        <Route
          exact
          path="/jioglass-privacy-policy"
          component={jioGlassPrivacyPolicy}
        />
        <Route
          exact
          path="/jioimmerse-android/privacy-policy"
          component={JioimmerseAndroidPrivacyPolicy}
        />
        <Route
          exact
          path="/jioimmerse-ios/privacy-policy"
          component={jioimmerseIosPrivacypolicy}
        />
        <Route
          exact
          path="/jiophotos-android/terms-and-conditions"
          component={JioPhotosAndroidTNC}
        />
        <Route
          exact
          path="/jiophotos-ios/terms-and-conditions"
          component={JioPhotosIosTNC}
        />
        <Route
          exact
          path="/jiophotos-android/privacy-policy"
          component={JioPhotosAndroidPrivacyPolicy}
        />
        <Route
          exact
          path="/jiophotos-ios/privacy-policy"
          component={JioPhotosIosPrivacyPolicy}
        />
        <Route
          exact
          path="/jiophotos-android/licences"
          component={JioPhotosAndroidLicences}
        />
        <Route
          exact
          path="/jiophotos-ios/licences"
          component={JioPhotosIosLicences}
        />
        <Route
          exact
          path="/tesseractportal-android/terms-and-conditions"
          component={TesseractPortalAndroidTNC}
        />
        <Route
          exact
          path="/tesseractportal-ios/terms-and-conditions"
          component={TesseractPortalIosTNC}
        />
        <Route
          exact
          path="/tesseractportal-android/privacy-policy"
          component={TesseractPortalAndroidPrivacyPolicy}
        />
        <Route
          exact
          path="/tesseractportal-ios/privacy-policy"
          component={TesseractPortalIosPrivacyPolicy}
        />
        <Route
          exact
          path="/tesseract-enterprise/terms-and-conditions"
          component={TesseractEnterpriseTNC}
        />
        <Route
          exact
          path="/tesseract-enterprise/privacy-policy"
          component={TesseractEnterprisePrivacyPolicy}
        />
        <Route exact path="/jioimmerse-android/licenses" component={Licences} />
        <Route exact path="/jioimmerse-ios/licenses" component={Licences} />
        <Route
          exact
          path="/dive/jioimmerse-android/licenses"
          component={Licences}
        />
        <Route
          exact
          path="/dive/jioimmerse-ios/licenses"
          component={Licences}
        />
        <Route
          exact
          path="/jioglass/jioimmerse-android/licenses"
          component={Licences}
        />
        <Route
          exact
          path="/jioglass/jioimmerse-ios/licenses"
          component={Licences}
        />
        <Route
          exact
          path="/tesseractportal-android/licenses"
          component={Licences}
        />
        <Route
          exact
          path="/tesseractportal-ios/licenses"
          component={Licences}
        />
        <Route exact path="/horizons/privacy-policy" component={HorizonPP} />
        <Route exact path="/horizons/terms-of-service" component={HorizonTNC} />
        <Route
          exact
          path="/enterprise/master-customer-agreement"
          component={HorizonMaster}
        />
        <Route exact path="/jioimmerse-desktop/terms-and-conditions" component={JioimmerseDesktopTnc} />
        <Route exact path="/jioimmerse-desktop/privacy-policy" component={JioimmerseDesktopPrivacyPolicy} />
      </BrowserRouter>
    </div>
  );
};

export default Routes;
